import React from 'react';
import {Pie as PieChart} from 'react-chartjs';

class ChartsPie extends React.Component {

  constructor() {
    super();
    const data = 
      [
      {
        value: 300,
        color:"#F7464A",
        highlight: "#FF5A5E",
        label: "Red"
      },
      {
        value: 50,
        color: "#46BFBD",
        highlight: "#5AD3D1",
        label: "Green"
      },
      {
        value: 100,
        color: "#FDB45C",
        highlight: "#FFC870",
        label: "Yellow"
        
      }
    ];

    const options = {	
      segmentShowStroke : true,
      segmentStrokeColor : "#fff",
      segmentStrokeWidth : 2,
      responsive: true,
    };
   
    
    this.state = {
      chartData: data,
      chartOptions: options,
    };
  };
 
  render() {

    const { chartData, chartOptions } = this.state;

    return(
    <div>
      <PieChart data={chartData} options={chartOptions} width="325" height="240"/> 
    </div>
    );
  }

}

export default ChartsPie;